import CloseIcon from "components/icons-svg/CloseIcon";
const ClearFilterButton = ({
  onClick
}: {
  onClick: () => void;
}) => {
  return <button onClick={onClick} className='flex h-7 w-auto items-center justify-center rounded-[5px] bg-offWhite px-3 text-sm font-medium shadow-[0_4px_12px_rgba(34,34,34,.2)] md:h-[43px] md:rounded-[10px]' aria-label='clear-filter' data-sentry-component="ClearFilterButton" data-sentry-source-file="ClearFilterButton.tsx">
      Clear Filters &nbsp;
      <CloseIcon className='h-4 w-4 md:h-5 md:w-5' data-sentry-element="CloseIcon" data-sentry-source-file="ClearFilterButton.tsx" />
    </button>;
};
export default ClearFilterButton;